export const PHOTO_BATCH_PHOTOS_UPLOAD_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};
